import React from 'react';
import { Box, Paper, Typography } from '@mui/material';
import {
  Groups as GroupsIcon,
  LocalAtm as LocalAtmIcon,
  HomeWork as HomeWorkIcon,
} from '@mui/icons-material';
import { formatCurrency } from '../../utils/formatters';

const CompactCard = ({ title, value, icon, color, featured }) => {
  return (
    <Paper
      sx={{
        flex: featured ? 2 : 1,
        minWidth: 0,
        p: 1.2,
        display: 'flex',
        flexDirection: 'column',
        gap: 0.6,
      }}
    >
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <Box
          sx={{
            p: 0.6,
            borderRadius: '8px',
            bgcolor: 'rgba(44, 156, 108, 0.08)',
            color: color,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            '& svg': { fontSize: '0.85rem' },
          }}
        >
          {icon}
        </Box>
        <Typography
          sx={{
            fontSize: '0.55rem',
            fontWeight: 600,
            textTransform: 'uppercase',
            letterSpacing: '0.03em',
            color: 'text.secondary',
            textAlign: 'right',
            lineHeight: 1.2,
          }}
        >
          {title}
        </Typography>
      </Box>
      <Box
        sx={{
          bgcolor: '#F0F3F2',
          borderRadius: '6px',
          p: 0.8,
        }}
      >
        <Typography
          noWrap
          sx={{
            fontSize: featured ? '1.15rem' : '0.95rem',
            fontWeight: 700,
            color: 'text.primary',
          }}
        >
          {value}
        </Typography>
      </Box>
    </Paper>
  );
};

const MobileStatCards = ({ stats, viewMode, t }) => {
  return (
    <Box sx={{ display: 'flex', gap: 0.75, mb: 1.5 }}>
      <CompactCard
        title={viewMode === 'agency' ? t('dashboard.agencies') : t('dashboard.agents')}
        value={viewMode === 'agency' ? stats?.uniqueAgencies || 0 : stats?.uniqueAgents || 0}
        icon={<GroupsIcon />}
        color="#2C9C6C"
      />
      <CompactCard
        title={t('common.ap')}
        value={formatCurrency(stats?.totalAP || 0)}
        icon={<LocalAtmIcon />}
        color="#4DC896"
        featured
      />
      <CompactCard
        title={t('dashboard.households')}
        value={stats?.totalCloses || 0}
        icon={<HomeWorkIcon />}
        color="#c9a84c"
      />
    </Box>
  );
};

export default MobileStatCards;
